import { InjectionToken } from "@angular/core";

export const APP_LANGUAGE_TOKEN = new InjectionToken<string | undefined>("APP_LANGUAGE_TOKEN");
